var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHiringContract(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.78 18.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #005b62;\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Quote_request",
    "data-name": "Quote request"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.09,18.28h-3.08c-.83,0-1.51-.67-1.51-1.51V2.01c0-.83.67-1.51,1.51-1.51h7.23c.42,0,.79.17,1.07.44l1.51,1.51c.27.27.44.65.44,1.07v4.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.71,8.47c.59-.59,1.54-.59,2.13,0,.59.59.59,1.54,0,2.13l-6.23,6.23c-.11.11-.23.2-.37.27l-2.11,1.09c-.28.15-.64.1-.88-.14-.24-.24-.28-.6-.14-.88l1.09-2.11c.07-.14.16-.26.27-.37l6.23-6.23Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.51,
    y1: 6.23,
    x2: 9.24,
    y2: 6.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.51,
    y1: 9.24,
    x2: 9.24,
    y2: 9.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.51,
    y1: 12.26,
    x2: 6.23,
    y2: 12.26
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiringContract);
export default __webpack_public_path__ + "static/media/hiring-contract.ebfa28c996bb9df6f1ab70896fa1da92.svg";
export { ForwardRef as ReactComponent };